import React from 'react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Edit3, Save, X, Plus, RotateCcw } from 'lucide-react';
interface EditModeToggleProps {
  isEditMode: boolean;
  onToggle: () => void;
  onCancel?: () => void;
  onReset?: () => void;
  onAddWidget?: () => void;
}
export const EditModeToggle: React.FC<EditModeToggleProps> = ({
  isEditMode,
  onToggle,
  onCancel,
  onReset,
  onAddWidget
}) => {
  if (!isEditMode) {
    return <Button 
      onClick={onToggle} 
      variant="outline" 
      className="flex items-center gap-2"
      aria-label="Activer le mode édition"
    >
        <Edit3 className="w-4 h-4" aria-hidden="true" />
        Mode édition
      </Button>;
  }
  return <div className="flex items-center gap-2" role="toolbar" aria-label="Barre d'outils d'édition">
      {onCancel && <Button 
        onClick={onCancel} 
        variant="outline" 
        size="sm" 
        className="flex items-center gap-2"
        aria-label="Annuler les modifications"
      >
          <X className="w-4 h-4" aria-hidden="true" />
          Annuler
        </Button>}
      
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button 
            variant="default" 
            className="flex items-center gap-2 bg-red-700 hover:bg-red-600"
            aria-label="Menu des actions d'édition"
            aria-haspopup="true"
          >
            <Save className="w-4 h-4" aria-hidden="true" />
            Actions d'édition
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={onToggle}>
            <Save className="w-4 h-4 mr-2" aria-hidden="true" />
            Sauvegarder la disposition
          </DropdownMenuItem>
          {onAddWidget && <DropdownMenuItem onClick={onAddWidget}>
              <Plus className="w-4 h-4 mr-2" aria-hidden="true" />
              Ajouter un widget
            </DropdownMenuItem>}
          <DropdownMenuSeparator />
          {onReset && <DropdownMenuItem onClick={onReset}>
              <RotateCcw className="w-4 h-4 mr-2" aria-hidden="true" />
              Réinitialiser
            </DropdownMenuItem>}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>;
};